import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import MoreFilterMenuLegacy from './_do_not_import_/MoreFilterMenu';
import MoreFilterMenuV2, { IMoreFilterMenuProps } from './_do_not_import_v2_/MoreFilterMenu';

export const MoreFilterMenu = (props: IMoreFilterMenuProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <MoreFilterMenuV2 {...props} />;
  }

  return <MoreFilterMenuLegacy {...props} />;
};
